import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import { configureTagKeys } from './query-key-factory';

const GET_TAGS = 'api/posv3/maintenance/get-tags';

type Tag = {
  TagId: number;
  TagName: string;
};

export function useTagsQuery() {
  return useQuery({
    queryKey: configureTagKeys.all,
    queryFn: () => fetchData<Tag[]>(GET_TAGS),
  });
}
